import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function Assignments() {
  const { user, signOut } = useAuth()
  const email = user?.email || ''
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [items, setItems] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    let active = true
    ;(async () => {
      setLoading(true)
      setError('')

      const today = new Date()
      const from = new Date(today)
      from.setDate(today.getDate() - 3)
      const to = new Date(today)
      to.setDate(today.getDate() + 7)

      const fromStr = from.toISOString().slice(0, 10)
      const toStr = to.toISOString().slice(0, 10)

      const { data, error: rpcError } = await supabase.rpc('get_student_assignments', {
        p_from: fromStr,
        p_to: toStr,
      })
      if (!active) return
      if (rpcError) {
        setError(rpcError.message || 'حدث خطأ أثناء تحميل الواجبات')
        setItems([])
      } else {
        setItems(data || [])
      }
      setLoading(false)
    })()
    return () => { active = false }
  }, [])

  function formatDate(d) {
    if (!d) return ''
    return String(d)
  }

  const today = new Date()
  const from = new Date(today)
  from.setDate(today.getDate() - 3)
  const to = new Date(today)
  to.setDate(today.getDate() + 7)

  const rangeLabel = `${from.toLocaleDateString('ar-EG', { day: 'numeric', month: 'long' })} 
إلى ${to.toLocaleDateString('ar-EG', { day: 'numeric', month: 'long' })}`

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: '1.5rem',
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 16,
            padding: 16,
            boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 16,
            }}
          >
            <h1 style={{ margin: 0, fontSize: 22 }}>الواجبات</h1>
            <button
              type="button"
              onClick={signOut}
              style={{
                padding: '6px 10px',
                borderRadius: 999,
                border: '1px solid #e5e7eb',
                background: '#f9fafb',
                cursor: 'pointer',
                fontSize: 13,
              }}
            >
              تسجيل الخروج
            </button>
          </div>

          {email && (
            <p style={{ marginBottom: 8 }}>تم تسجيل الدخول بالبريد: <strong>{email}</strong></p>
          )}

          {loading && (
            <div style={{ textAlign: 'center', marginTop: 24 }}>جاري تحميل الواجبات...</div>
          )}

          {!loading && error && (
            <div style={{ color: '#b91c1c', marginTop: 16 }}>{error}</div>
          )}

          {!loading && !error && items.length === 0 && (
            <div style={{ marginTop: 16 }}>لا يوجد واجبات في الفترة المحددة.</div>
          )}

          {!loading && !error && items.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, marginTop: 16 }}>
              {items.map((a) => (
                <li
                  key={a.id}
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 8,
                    background: '#fff',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <div style={{ fontWeight: 600 }}>{a.title}</div>
                    <div
                      style={{
                        padding: '2px 8px',
                        borderRadius: 999,
                        fontSize: 11,
                        background: a.type === 'daily' ? '#eff6ff' : '#fef3c7',
                        color: a.type === 'daily' ? '#1d4ed8' : '#92400e',
                        border: '1px solid #e5e7eb',
                      }}
                    >
                      {a.type === 'daily' ? 'صفية' : 'منزلية'}
                    </div>
                  </div>
                  <div style={{ marginBottom: 2 }}>
                    المادة: <strong>{a.subject_name || 'غير محددة'}</strong>
                  </div>
                  <div style={{ marginBottom: 2 }}>
                    {a.type === 'daily'
                      ? (
                        <>التاريخ: <strong>{formatDate(a.assigned_on)}</strong></>
                      )
                      : (
                        <>تاريخ التسليم: <strong>{formatDate(a.due_date)}</strong></>
                      )}
                  </div>
                  {a.description && (
                    <div style={{ marginTop: 4, fontSize: 14, color: '#4b5563' }}>
                      {a.description}
                    </div>
                  )}
                  {a.attachments && (
                    <div style={{ marginTop: 4, fontSize: 12, color: '#6b7280' }}>
                      يوجد مرفقات لهذا الواجب.
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
